import { safeDefine } from "../../registration/safe-define.js";
import { SeekIndicatorElement } from "../../ui/seek-indicator/element.js";
//#region src/define/ui/seek-indicator.ts
safeDefine(SeekIndicatorElement);
//#endregion

//# sourceMappingURL=seek-indicator.js.map